import React, { useState } from "react";
import { Upload } from "lucide-react";
import { uploadVideoFile } from "../../lib/adminApi";
import { resolveMediaUrl } from "../../lib/mediaUrl";
import { AdminField } from "./AdminUi";

export function VideoSourceInput({
  youtubeUrl,
  videoFileUrl,
  onYoutubeChange,
  onVideoFileChange,
  className = "",
}) {
  const [mode, setMode] = useState(() =>
    videoFileUrl?.startsWith("/uploads") ? "file" : "youtube"
  );
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setUploadError("");
    try {
      const { url } = await uploadVideoFile(file);
      onVideoFileChange(url);
      onYoutubeChange("");
      setMode("file");
    } catch {
      setUploadError("Video yüklenemedi. Format ve boyutu kontrol edin.");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  const fileSrc = videoFileUrl ? resolveMediaUrl(videoFileUrl) : null;

  return (
    <AdminField label="Video kaynağı" className={className}>
      <div className="flex gap-2 mb-2">
        <button
          type="button"
          onClick={() => setMode("youtube")}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            mode === "youtube"
              ? "bg-[var(--tv-purple)] text-white"
              : "bg-[rgba(255,255,255,0.06)] text-[var(--tv-muted)] hover:text-white"
          }`}
        >
          YouTube URL
        </button>
        <button
          type="button"
          onClick={() => setMode("file")}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors inline-flex items-center gap-1.5 ${
            mode === "file"
              ? "bg-[var(--tv-purple)] text-white"
              : "bg-[rgba(255,255,255,0.06)] text-[var(--tv-muted)] hover:text-white"
          }`}
        >
          <Upload size={12} /> Video yükle
        </button>
      </div>

      {mode === "youtube" ? (
        <input
          value={youtubeUrl}
          onChange={(e) => {
            onYoutubeChange(e.target.value);
            if (e.target.value) onVideoFileChange("");
          }}
          className="tv-input"
          placeholder="https://youtube.com/watch?v=..."
        />
      ) : (
        <div>
          <input
            type="file"
            accept="video/mp4,video/webm,video/quicktime"
            onChange={handleFile}
            disabled={uploading}
            className="tv-input file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:text-xs file:bg-[var(--tv-purple)] file:text-white"
          />
          {uploading && <p className="text-xs text-[var(--tv-muted)] mt-1">Yükleniyor...</p>}
        </div>
      )}

      {uploadError && <p className="text-xs text-red-400 mt-1">{uploadError}</p>}

      {fileSrc && mode === "file" && (
        <video
          src={fileSrc}
          controls
          className="mt-3 w-full max-h-40 rounded-lg border border-[var(--tv-border)] bg-black"
        />
      )}
    </AdminField>
  );
}
